import React from 'react';
import { Link } from 'react-router-dom'

function accessor(str) {
  return str.split('.')[0];
}

function endpoint(str) {
  return str.split('.')[1];
}

function toString(v) {
  return v.toString();
}

const warrantyMap = {
  '_id': {
    fields: '__self',
    headers: 'Record Id',
    editable: false,
    format: id => <Link to={ `/admin/limited_warranty/${id}` }> { id } </Link>,
    _index: 0
  },
  warrantyApproved: {
    fields: '__self',
    headers: 'Approved',
    editable: true,
    format: v => v ? 'Approved' : 'Denied',
    _index: 1
  },
  warrantyDenied: {
    fields: '__self',
    headers: 'Denied',
    editable: true,
    format: v => v ? 'Approved' : 'Denied',
    _index: 2
  },
  'administrationDate': {
    fields: '__self',
    headers: 'Administration Date',
    editable: false,
    _index: 3
  },
  'authorizationVerification': {
    fields: '__self',
    headers: 'Authorization Verification',
    editable: false,
    _index: 4
  },
  'contact': {
    fields: [
      'authorizedRepresentativeName',
      'authorizedRepresentativeTitle',
      'phoneNumber',
      'hospitalName'
    ],
    headers: [
      'Representative Name',
      'Representative Title',
      'Phone Number',
      'Hospital'
    ],
    editable: false,
    _index: [6, 7, 8, 9]
  },
  // 'eSignature': {
    //   fields: '__self',
    //   headers: 'E-Signature',
    //   editable: false,
    //   _index: 8
    // },
    // 'invoiceNumber': {
      //   fields: '__self',
      //   headers: 'Invoice Number',
      //   editable: false,
      //   _index: 9
      // },
      'purchaseDate': {
        fields: '__self',
        headers: 'Purchase Date',
        editable: false,
        _index: 10
      },
      'requestedVials': {
        fields: '__self',
        headers: 'Requested Vials',
        editable: false,
        _index: 11
      },
      'date': {
        fields: '__self',
        headers: 'Signed Date',
        editable: false,
        _index: 12
      },
  // 'shipping': {
  //   fields: [
  //     'address1',
  //     'address2',
  //     'city',
  //     'state',
  //     'zipCode'
  //   ],
  //   headers: [
  //     'Address 1',
  //     'Address 2',
  //     'City',
  //     'State',
  //     'Zip'
  //   ],
  //   editable: false,
  //   _index: [12,13,14,15,16]
  // },
  // 'termsVerify': {
  //   fields: '__self',
  //   headers: 'Terms Accepted',
  //   editable: false,
  //   _index: 17
  // },

//   note: {
//     fields: '__self',
//     headers: 'Notes',
//     editable: true,
//     _index: 19
//   }
}

const destructionMap = {
  '_id': {
    fields: '__self',
    headers: 'Record Id',
    editable: false,
    format: id => <Link to={ `/admin/cert/${id}` }> { id } </Link>,
    _index: -2
  },
  'destructionApproved': {
    fields: '__self',
    headers: 'Approved',
    editable: true,
    format: v => v ? 'Approved' : 'Denied',
    _index: -1
  },
  vialsDestroyed: {
    fields: '__self',
    headers: 'Vials Destroyed',
    editable: false,
    _index: 0
  },
  hospitalName: {
    fields: '__self',
    headers: 'Hospital',
    editable: false,
    _index: 1
  },
  // hospitalAddress: {
  //   fields: '__self',
  //   headers: 'Hospital Address',
  //   editable: false,
  //   _index: 2
  // },
  authorizedRepresentativeName: {
    fields: '__self',
    headers: 'Authorized Representative Name',
    editable: false,
    _index: 3
  },
  authorizedRepresentativeTitle: {
    fields: '__self',
    headers: 'Authorized Representative Title',
    editable: false,
    _index: 4
  },
  email: {
    fields: '__self',
    headers: 'Contact Email',
    editable: false,
    _index: 5
  },
  // phone: {
  //   fields: '__self',
  //   headers: 'Contact Phone',
  //   editable: false,
  //   _index: 6
  // },
  // eSignature: {
  //   fields: '__self',
  //   headers: 'E-Signature',
  //   editable: false,
  //   _index: 7
  // },
  date: {
    fields: '__self',
    headers: 'Signed Date',
    editable: false,
    _index: 8
  },
  // note: {
  //   fields: '__self',
  //   headers: 'Notes',
  //   editable: true,
  //   _index: 10
  // }
}

const wastageMap = {
  '_id': {
    fields: '__self',
    headers: 'Record Id',
    editable: false,
    format: id => <Link to={ `/admin/wastage/${id}` }> { id } </Link>,
    _index: -1
  },
  'destructionFormId': {
    fields: '__self',
    headers: 'Destruction Record',
    editable: false,
    format: id => <Link to={ `/admin/cert/${id}` }> { 'Destruction Form' } </Link>,
    _index: 0
  },
  'destructionApproved': {
    fields: '__self',
    headers: 'Destruction Certificate',
    editable: false,
    format: (v, id) => <Link to={ `/admin/cert/${id}` }> {  v === 'Pending' ? 'Not Reviewed' : v ?  'Approved' : 'Denied' } </Link> ,
    _index: 1
  },
  'wastageApproved': {
    fields: '__self',
    headers: 'Is Eligible',
    editable: true,
    _index: 2
  },
  'wastageDenied': {
    fields: '__self',
    headers: 'Denied',
    editable: true,
    _index: 3
  },
  finalApproved: {
    fields: '__self',
    headers: 'Final Approval',
    editable: true,
    _index: 4
  },
  'mixedDate': {
    fields: '__self',
    headers: 'Open and Mixed Date',
    editable: false,
    _index: 5
  },
  'requestedVials': {
    fields: '__self',
    headers: 'Requested Vials',
    editable: false,
    _index: 6
  },
  // 'authorizedDistributor': {
  //   fields: '__self',
  //   headers: 'Authorized Distributor',
  //   editable: false,
  //   _index: 2
  // },
  // 'invoiceNumber': {
  //   fields: '__self',
  //   headers: 'Invoice Number',
  //   editable: false,
  //   _index: 3
  // },
  'purchaseDate': {
    fields: '__self',
    headers: 'Purchase Date',
    editable: false,
    _index: 8
  },
  'contact': {
    fields: [
      'authorizedRepresentativeName',
      'authorizedRepresentativeTitle',
      'phoneNumber',
      'hospitalName'
    ],
    headers: [
      'Representative Name',
      'Representative Title',
      'Phone Number',
      'Hospital'
    ],
    editable: false,
    _index: [ 9, 10, 11, 12]
  },
  // 'shipping': {
  //   fields: [
  //     'address1',
  //     'address2',
  //     'city',
  //     'state',
  //     'zipCode'
  //   ],
  //   headers: [
  //     'Address 1',
  //     'Address 2',
  //     'City',
  //     'State',
  //     'Zip'
  //   ],
  //   editable: false,
  //   _index: [9, 10,11,12,13]
  // },
  'licenseURL': {
    fields: '__self',
    headers: 'License',
    editable: false,
    format: url => <a href={ url }> { 'License Attachment' } </a>,
    _index: 13
  },
  'authorizationVerification': {
    fields: '__self',
    headers: 'Authorization Verification',
    editable: false,
    _index: 14
  },
  // 'termsVerify': {
  //   fields: '__self',
  //   headers: 'Terms Accepted',
  //   editable: false,
  //   _index: 16
  // },
  // 'eSignature': {
  //   fields: '__self',
  //   headers: 'E-Signature',
  //   editable: false,
  //   _index: 17
  // },
  'date': {
    fields: '__self',
    headers: 'Signed Date',
    editable: false,
    _index: 15
  },
  // 'note': {
  //   fields: '__self',
  //   headers: 'Notes',
  //   editable: true,
  //   _index: 23
  // }
}

function stripValues(obj) {
  return Object.keys(obj).reduce((acc, v) => Object.assign(acc, { [v]: 'Pending' }), {})
}

function createTable(map, data) {
  const headers = Object.entries(map)
    .reduce((acc, [key, value]) => {
      return acc.concat(value.headers)
    }, []);
  const reducer = (acc, record, i) => {
    const result = Object.entries(Object.assign(stripValues(map), record)) //ensure all properties have values
    .reduce((row, [key, value]) => {
      let cells;
      if (!map[key]) return row;
      if (map[key].fields === '__self') {
        cells = {
          key,
          value,
          editable: map[key].editable,
          format: map[key].format
        }
      } else {
        cells = map[key].fields.map(v => {
          return {
            key: `${ key }.${ v }`,
            value: record[key][v],
            editable: map[key].editable,
            format: map[key].format
          }
        });
      }
      return row.concat(cells).sort((a, b) => { //yikes - this ensures that the cell order matches the column headers
        if (map[a.key] && map[b.key]) {
          return map[a.key]._index - map[b.key]._index
        }
        if (!map[b.key] && map[a.key]) {
          let nested = map[accessor(b.key)];
          return map[a.key]._index - nested._index[nested.fields.indexOf(endpoint(b.key))]
        }
        if (map[b.key] && !map[a.key]) {
          let nested = map[accessor(a.key)];
          return nested._index[nested.fields.indexOf(endpoint(a.key))] - map[b.key]._index
        }
        else {
          let nestedA = map[accessor(a.key)];
          let nestedB = map[accessor(b.key)];
          return nestedA._index[nestedA.fields.indexOf(endpoint(a.key))] - nestedB._index[nestedB.fields.indexOf(endpoint(b.key))];
        }

      })
    }, [])
    acc[i] = {
      _id: record._id,
      cells: result
    };
    return acc;
  }

  const records = data
    .sort((a, b) =>  {
      return (b.createdAt || 0) - (a.createdAt || 0);
    })
    .reduce(reducer, []);

  return {
    headers,
    records
  }
}

export {
  createTable,
  warrantyMap,
  wastageMap,
  destructionMap
}
